import VerifyUdyogAadhaar from "./containers";

export default VerifyUdyogAadhaar;
